import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../config";
import Sidebar from "./Sidebar";
import AssessmentTopNav from "./topnav";
import axios from "axios";
import "../../../Styles/Admin/assessment/Questions.css";

const Questions = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [questions, setQuestions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [search, setSearch] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("add");
  const [modalQuestion, setModalQuestion] = useState({
    id: null,
    question_text: "",
    category: "",
    points: 1,
  });

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteQuestionId, setDeleteQuestionId] = useState(null);

  const [successAlert, setSuccessAlert] = useState("");
  const [errorAlert, setErrorAlert] = useState("");

  useEffect(() => {
    fetchCategories();
  }, []);

  // Pick up the category from the URL query param, e.g. when arriving from
  // the Quizzes page "X Questions" badge.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const cat = params.get("category") || "";
    setSelectedCategory(cat);
  }, [location.search]);

  useEffect(() => {
    if (selectedCategory) {
      fetchQuestions(selectedCategory);
    } else {
      setQuestions([]);
      setFiltered([]);
    }
  }, [selectedCategory]);

  useEffect(() => {
    applyFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, search]);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/quizzes`);
      setCategories(res.data.map((q) => q.category));
    } catch (err) {
      console.error(err);
    }
  };

  const fetchQuestions = async (category) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/questions/${encodeURIComponent(category)}`
      );
      setQuestions(res.data);
    } catch (err) {
      setQuestions([]);
    }
  };

  const applyFilters = () => {
    if (!search.trim()) {
      setFiltered(questions);
      return;
    }
    const term = search.toLowerCase();
    setFiltered(
      questions.filter((q) => q.question_text.toLowerCase().includes(term))
    );
  };

  const selectCategory = (cat) => {
    setSelectedCategory(cat);
    setSearch("");
    setFilterOpen(false);
  };

  const openAddModal = () => {
    setModalType("add");
    setModalQuestion({
      id: null,
      question_text: "",
      category: selectedCategory,
      points: 1,
    });
    setModalOpen(true);
  };

  const openEditModal = (question) => {
    setModalType("edit");
    setModalQuestion({
      id: question.id,
      question_text: question.question_text,
      category: question.category,
      points: question.points,
    });
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalQuestion({
      id: null,
      question_text: "",
      category: selectedCategory,
      points: 1,
    });
  };

  const handleModalChange = (e) => {
    setModalQuestion({ ...modalQuestion, [e.target.name]: e.target.value });
  };

  const handleModalSave = async () => {
    if (!modalQuestion.question_text.trim() || !modalQuestion.category) return;
    try {
      if (modalType === "add") {
        await axios.post(`${API_BASE_URL}/api/questions`, {
          question_text: modalQuestion.question_text,
          category: modalQuestion.category,
          points: modalQuestion.points || 1,
        });
        setSuccessAlert("Question added successfully!");
      } else {
        await axios.post(
          `${API_BASE_URL}/api/questions/edit/${modalQuestion.id}`,
          {
            question_text: modalQuestion.question_text,
            category: modalQuestion.category,
            points: modalQuestion.points || 1,
          }
        );
        setSuccessAlert("Question updated successfully!");
      }
      closeModal();
      fetchQuestions(selectedCategory);
      setTimeout(() => setSuccessAlert(""), 2000);
    } catch (err) {
      console.error(err);
    }
  };

  const openDeleteModal = (id) => {
    setDeleteQuestionId(id);
    setDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteQuestionId(null);
    setDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    try {
      await axios.post(`${API_BASE_URL}/api/questions/delete/${deleteQuestionId}`);
      closeDeleteModal();
      fetchQuestions(selectedCategory);
      setErrorAlert("Question deleted successfully!");
      setTimeout(() => setErrorAlert(""), 2000);
    } catch (err) {
      console.error(err);
    }
  };

  const formatPoints = (points) => {
    const n = Number(points);
    return Number.isFinite(n) ? n.toFixed(2) : points;
  };

  return (
    <div className="questions-layout">
      <Sidebar />
      <div className="questions-content-col">
        <AssessmentTopNav title="ASSESSMENT" />
        <main className="questions-main">
          <header className="questions-header">
            <h1 className="questions-title">Questions</h1>
            <p className="questions-subtitle">
              Manage and Organize under selected quizze
            </p>
          </header>

          <section className="questions-toolbar-card">
            <div className="questions-filter-wrap">
              <button
                type="button"
                className="questions-filter-btn"
                onClick={() => setFilterOpen((open) => !open)}
              >
                <img
                  src="/filters_icon.png"
                  alt=""
                  className="questions-filter-icon"
                />
                <span>{selectedCategory || "Select Category"}</span>
                <img
                  src="/drop_downs_icons.png"
                  alt=""
                  className="questions-chevron-icon"
                />
              </button>
              {filterOpen && (
                <ul className="questions-filter-dropdown">
                  {categories.map((cat) => (
                    <li key={cat}>
                      <button
                        type="button"
                        className="questions-filter-option"
                        onClick={() => selectCategory(cat)}
                      >
                        {cat}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="questions-search-wrap">
              <img
                src="/searchs_icon.png"
                alt=""
                className="questions-search-icon"
              />
              <input
                type="text"
                placeholder="Search Question by keyword"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="questions-search-input"
                disabled={!selectedCategory}
              />
            </div>

            <button
              className="questions-add-btn"
              onClick={openAddModal}
              disabled={!selectedCategory}
            >
              <img
                src="/plus_icons.png"
                alt=""
                className="questions-plus-icon"
              />
              Add New Questions
            </button>
          </section>

          {successAlert && (
            <div className="questions-success-alert">{successAlert}</div>
          )}
          {errorAlert && (
            <div className="questions-error-alert">{errorAlert}</div>
          )}

          <section className="questions-table-card">
            <div className="questions-table-scroll">
              <table className="questions-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Questions</th>
                    <th>Quizze</th>
                    <th>Points</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.length === 0 ? (
                    <tr>
                      <td colSpan={5} className="questions-empty-cell">
                        {selectedCategory
                          ? "No questions found."
                          : "Please select a quizze to view its questions."}
                      </td>
                    </tr>
                  ) : (
                    filtered.map((q, idx) => (
                      <tr key={q.id}>
                        <td>{String(idx + 1).padStart(2, "0")}</td>
                        <td className="questions-text-cell">
                          {q.question_text}
                        </td>
                        <td>
                          <span className="questions-quiz-badge">
                            {q.category}
                          </span>
                        </td>
                        <td>{formatPoints(q.points)}</td>
                        <td>
                          <div className="questions-actions-cell">
                            <button
                              className="questions-edit-btn"
                              onClick={() => openEditModal(q)}
                            >
                              <img
                                src="/edits_out_icon.png"
                                alt=""
                                className="questions-btn-icon"
                              />
                              Edit
                            </button>
                            <button
                              className="questions-delete-btn"
                              onClick={() => openDeleteModal(q.id)}
                            >
                              <img
                                src="/deletes_out_icon.png"
                                alt=""
                                className="questions-btn-icon"
                              />
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </section>

          <button
            type="button"
            className="questions-back-btn"
            onClick={() => navigate("/admin/assessment/quizzes")}
          >
            <img
              src="/back_qu_icon.png"
              alt=""
              className="questions-back-icon"
            />
            Back
          </button>
        </main>
      </div>

      {modalOpen && (
        <div className="questions-modal-overlay">
          <div className="questions-modal">
            <div className="questions-modal-title">
              {modalType === "add" ? "Add New Question" : "Edit Question"}
            </div>

            <label className="questions-modal-label" htmlFor="category">
              Quiz name
            </label>
            <div className="questions-select-wrap">
              <select
                className="questions-modal-input questions-modal-select"
                id="category"
                name="category"
                value={modalQuestion.category}
                onChange={handleModalChange}
              >
                <option value="" disabled>
                  Enter Quiz name
                </option>
                {categories.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
              <img
                src="/drop_downs_icons.png"
                alt=""
                className="questions-select-chevron"
              />
            </div>

            <label className="questions-modal-label" htmlFor="question_text">
              Question
            </label>
            <input
              className="questions-modal-input"
              id="question_text"
              name="question_text"
              value={modalQuestion.question_text}
              onChange={handleModalChange}
              placeholder="Enter Question"
              autoFocus
            />

            <label className="questions-modal-label" htmlFor="points">
              Points
            </label>
            <input
              className="questions-modal-input"
              id="points"
              name="points"
              type="number"
              min="0"
              step="0.01"
              value={modalQuestion.points}
              onChange={handleModalChange}
              placeholder="Enter Points"
            />

            <div className="questions-modal-actions">
              <button className="questions-modal-cancel" onClick={closeModal}>
                Cancel
              </button>
              <button
                className="questions-modal-save"
                onClick={handleModalSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {deleteModalOpen && (
        <div className="questions-delete-modal-overlay">
          <div className="questions-delete-modal">
            <div className="delete-icon">
              <img
                src="/delete_alert_icons.png"
                alt=""
                className="delete-icon-img"
              />
            </div>
            <div className="questions-delete-modal-title">
              Delete Information
            </div>
            <div className="questions-delete-modal-desc">
              This Record will be deleted
            </div>
            <div className="questions-delete-modal-actions">
              <button
                className="questions-delete-modal-no"
                onClick={closeDeleteModal}
              >
                No, Keep it
              </button>
              <button
                className="questions-delete-modal-yes"
                onClick={confirmDelete}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Questions;